import { keepApiAlive } from "./apiService";

/**
 * Initialize background keep-alive pings to keep the Render API awake
 * This is necessary because Render's free tier sleeps services after 15 minutes of inactivity
 */
export const initializeKeepAlive = () => {
  // Initial ping immediately
  keepApiAlive();

  // Then ping every 5 minutes
  const interval = setInterval(keepApiAlive, 5 * 60 * 1000);

  // Return cleanup function
  return () => clearInterval(interval);
};

export default { initializeKeepAlive };
